// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__CavwJ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1BtZR","obliqueLine":"membershipbadge_obliqueLine__3qMBm"};